var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"rules"}},_vm._l((_vm.rules),function(item,index){return _c('rule',{key:index,staticClass:"column",attrs:{"rule":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }